import RcPagination from 'rc-pagination';
import './styles/index.css';
import React, {FC} from 'react';

interface IPagination {
    onChange: any,
    total: number,
    pageSize?: number,
    activePage?: number,
}

const Pagination: FC<IPagination> = ({onChange, total, pageSize, activePage}) => {
    return (
        <>
            {total > 0 &&
                <RcPagination
                    onChange={onChange}
                    showTitle={false}
                    showLessItems
                    total={total}
                    pageSize={pageSize}
                    defaultPageSize={10}
                    current={activePage}
                    onShowSizeChange={onChange}
                    showPrevNextJumpers={false}
                />
            }
        </>
    );
};

export default Pagination;